import { Box, ColorOptions, Image, ModBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { EmType } from '..'
import { ButtonNew } from '../../../components/AdminButton'
import { VerticalStepIndicator } from '../../../components/VerticalStepIndicator'
import { RootStore, useLazyApiData, useStores } from '../../../data/store'
import { isAccessible, MessageTypes } from '../../../utils'
import { FullScreenLoader } from '../../EntityOnboarding/OnboardEntity/comps/FullScreenLoader'
import { BusinessDetails } from '../Onboarding/BusinessDetails'
import { ContactProfiles } from '../Onboarding/ContactProfiles'
import { CreateEntity } from '../Onboarding/CreateEntity'
import { StatusComp } from '../Onboarding/CreationStatus/StatusComp'
import { styles } from '../styles'

const Header = ({ currentStep, selectedGroupName, groupBusinessName, selectedSubGroupName, showAllFields }: any) => {
  const [showAttributes, setShowAttributes] = useState(true)
  const onToggleShowAllAttributes = () => {
    setShowAttributes((prev) => {
      const state = !prev
      showAllFields(state)
      return state
    })
  }
  return (
    <Box {...styles.header} w={'100%'}>
      <Text title={'Create Entity'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox direction="row" justifyContent={'space-between'} alignItems={'center'} flex={2}>
        <ModBox direction="row" flex={1.7}>
          <ModBox show={currentStep > 1} direction={'row'} marginLeft={24}>
            <Box backgroundColor={'#F0F0F0' as ColorOptions} borderRadius={2} padding={4} direction={'row'}>
              <Text title={'Group: '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text
                title={
                  selectedGroupName?.length > 0
                    ? selectedGroupName
                    : groupBusinessName?.length > 0
                    ? groupBusinessName
                    : 'NA'
                }
                color={'BLACK_21'}
                fontSize={12}
                fontFamily={'jiotype-bold'}
              />
            </Box>
          </ModBox>
          <ModBox show={currentStep > 1} direction={'row'} marginLeft={24}>
            <Box backgroundColor={'#F0F0F0' as ColorOptions} borderRadius={2} padding={4} direction={'row'}>
              <Text title={'Parent: '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text
                title={selectedSubGroupName?.length > 0 ? selectedSubGroupName : 'NA'}
                color={'BLACK_21'}
                fontSize={12}
                fontFamily={'jiotype-bold'}
              />
            </Box>
          </ModBox>
        </ModBox>
        <ModBox show={currentStep === 2} flex={0.3}>
          <ModBox
            underlayColor={'TRANSPARENT'}
            h={32}
            alignItems={'center'}
            justifyContent={'center'}
            borderWidth={1}
            borderColor={'#E0E0E0' as ColorOptions}
            borderRadius={4}
            onPress={onToggleShowAllAttributes}
            direction="row"
            padding={8}>
            <Image
              source={
                showAttributes
                  ? require('../../../assets/images/ic_hide.svg')
                  : require('../../../assets/images/ic_show.svg')
              }
              height={24}
              width={24}
              resizeMode="center"
            />
            <Spacer direction="horizontal" size={10} />
            <TextNew
              title={showAttributes ? 'Hide Attributes' : 'Show Attributes'}
              fontSize={12}
              fontFamily={'jiotype-medium'}
            />
          </ModBox>
        </ModBox>
      </ModBox>
    </Box>
  )
}
const Footer = ({
  hide,
  setCurrentStep,
  currentStep,
  entityParentTypeSelected,
  setCreateEntityValid,
  setBusinessdataValid,
  setCreationStatusValid,
  setContactProfileValid,
  setIsReset,
  createEntityValid,
  isBusinessDataValid,
  isContactProfileValid,
  onSavePressed,
  saveContactProfileData,
  resetCreateSingleEntitySelections,
  isLoading,
}: any) => {
  const titles: any = {
    1: 'Save & Proceed To Business Details',
    2: 'Save & Proceed To Contact Profiles',
    3: 'Submit',
  }
  const handleFooterPress = () => {
    console.log('currentStep !== 3 ', currentStep)
    currentStep !== 3 && setCurrentStep(currentStep + 1)
    /* !isLinkToMAS && currentStep !== 3 &&
    if (
      (isLinkToMAS && currentStep === 6) ||
      (!isLinkToMAS &&
        currentStep === 3 &&
        (entityParentTypeSelected === 'SubGroup' || entityParentTypeSelected === 'Entity')) ||
      (!isLinkToMAS && currentStep === 5)
    ) {
      setHideFooter(true)
    }*/
    onSavePressed()
  }
  const onCancelOnboarding = () => {
    setCurrentStep(1)
    setCreateEntityValid(false)
    setBusinessdataValid(false)
    setCreationStatusValid(false)
    setContactProfileValid(false)
    setIsReset(true)
    saveContactProfileData(false)
    resetCreateSingleEntitySelections()
  }

  const isValid: any = {
    1: createEntityValid,
    2: isBusinessDataValid,
    3: isContactProfileValid,
  }

  return (
    <ModBox show={!hide} {...styles.footer}>
      <ModBox justifyContent={'flex-start'} width={'15%'}>
        <ButtonNew
          type={'secondary'}
          borderWidth={1}
          height={40}
          title={'Cancel Onboarding'}
          borderColor={'#0070B6'}
          onPress={onCancelOnboarding}
          disabled={entityParentTypeSelected === ''}
        />
      </ModBox>
      <ModBox justifyContent={'flex-end'} direction="row" width={'85%'}>
        <ModBox show={false}>
          <ButtonNew
            type={'secondary'}
            borderWidth={1}
            height={40}
            title={'Save'}
            borderColor={'#0070B6'}
            onPress={onSavePressed}
            disabled={!isValid[currentStep]}
          />
        </ModBox>
        <Spacer size={32} direction={'horizontal'} />
        <ButtonNew
          onPress={handleFooterPress}
          title={titles[currentStep]}
          height={40}
          width={290}
          isLoading={isLoading} //state === 'pending'
          disabled={!isValid[currentStep]}
        />
      </ModBox>
    </ModBox>
  )
}

const CreateSingleEntity = () => {
  const {
    addContactProfile,
    entityParentTypeSelected,
    selectedSubGroupName,
    selectedGroupName,
    resetCreateSingleEntitySelections,
    groupBusinessName,
    saveBusinessData,
    saveContactProfileData,
    resetDataEntered,
    saveEnteredContactProfile,
    entityParentType,
    searchedSource,
    searchedMasMid,
    resetFeePkgId,
    isViewDetailsSearchFlow,
    accessConfig,
    createEntity,
    getEntityData,
  } = useStores((store) => ({
    addContactProfile: store.onboarding.addContactProfile,
    entityParentTypeSelected: store.onboarding.entityParentType,
    selectedSubGroupName: store.onboarding.selectedSubGroupName,
    selectedGroupName: store.onboarding.group.groupName,
    resetCreateSingleEntitySelections: store.onboarding.resetCreateSingleEntitySelections,
    groupBusinessName: store?.onboarding?.entityDetails?.entity?.businessName ?? '',
    saveBusinessData: store.onboarding.saveBusinessData,
    saveContactProfileData: store.onboarding.saveContactProfileData,
    resetDataEntered: store.onboarding.resetDataEntered,
    saveEnteredContactProfile: store.onboarding.saveEnteredContactProfile,
    entityParentType: store.onboarding.entityParentType,
    searchedSource: store.onboarding.searchEntity?.[0]?.entity?.source ?? '',
    searchedMasMid: store.onboarding.searchedMasMid,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    isViewDetailsSearchFlow: store.onboarding.isViewDetailsSearchFlow,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'single_entity']),
    createEntity: store.createEntity,
    getEntityData: store.onboarding.getEntityData,
  }))

  const navigation = useNavigation()

  const steps = ['Select Parent', 'Business Details', 'Contact Profiles']

  const [currentStep, setCurrentStep] = useState(1)
  const [isBusinessDataValid, setBusinessdataValid] = useState(false)
  const [creationStatusValid, setCreationStatusValid] = useState(false)
  const [createEntityValid, setCreateEntityValid] = useState(false)
  const [isContactProfileValid, setContactProfileValid] = useState(false)
  const [isReset, setIsReset] = useState(false)
  const [hideFooter, setHideFooter] = useState(false)
  const [showAllFields, setShowAllFields] = useState(true)
  const [createSingleEntity, createSingleEntityHandler] = useLazyApiData(createEntity)

  const isFocused = useIsFocused()
  useEffect(() => {
    if (!isViewDetailsSearchFlow) {
      resetDataEntered()
      setCurrentStep(isFocused ? 1 : -1)
    }
  }, [isFocused, isViewDetailsSearchFlow, resetDataEntered])

  useEffect(() => {
    if (createSingleEntityHandler.state === 'fulfilled') {
      setCurrentStep(4)
    }
  }, [createSingleEntityHandler?.state])

  useEffect(() => {
    resetCreateSingleEntitySelections()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onContactDataChange = (index: number, key: string, value: string) => {
    if (!saveEnteredContactProfile) {
      addContactProfile(index, key, value)
      console.log('onContactDataChange CreateGrp', index, key, value)
    }
  }

  const isCreateEntityValidToProceed = (isValid: boolean) => {
    setCreateEntityValid(isValid)
    resetFeePkgId()
  }

  const isContactProfValidToProceed = (isValid: boolean) => {
    setContactProfileValid(isValid)
  }

  const getBusinessDataValidity = (values: any, isValid: boolean) => {
    setBusinessdataValid(isValid)
  }

  const getScreen: any = {
    1: (
      <CreateEntity
        type={EmType.createSingleEntity}
        isValidToProceed={isCreateEntityValidToProceed}
        isReset={isReset}
      />
    ),
    2: (
      <BusinessDetails
        type={EmType.createSingleEntity}
        isValidToProceed={getBusinessDataValidity}
        showAllFields={showAllFields}
        isEditMode={createSingleEntityHandler.state !== 'fulfilled'}
      />
    ),
    3: (
      <ContactProfiles
        type={EmType.createSingleEntity}
        onDataChange={onContactDataChange}
        isValidToProceed={isContactProfValidToProceed}
        isEditable={createSingleEntityHandler.state !== 'fulfilled'}
        isEditMode={true}
      />
    ),
  }

  const onStepPressed = (stepPressed: number) => {
    console.log('stepPressed', stepPressed, currentStep)
    setCurrentStep(stepPressed)
    setHideFooter(false)
  }

  const onSavePressed = () => {
    if (currentStep === 2) {
      saveBusinessData(true)
    } else if (currentStep === 3) {
      saveContactProfileData(true)
      const entityData = getEntityData()
      createSingleEntity(entityData)
    }
  }

  const handleSetCurrentStep = (step: number) => {
    if (
      step === 2 &&
      entityParentType === 'Entity' &&
      searchedSource?.length > 0 &&
      searchedSource === 'MAS' &&
      searchedMasMid === ''
    ) {
      RootStore.message.setMessage('EMS only entity cannot be assigned as child to a MAS entity', MessageTypes.INFO)
      return
    }
    setCurrentStep(step)
  }

  const handleShowAllFields = (showHide: boolean) => {
    setShowAllFields(showHide)
  }
  console.log('createSingleEntityHandler ', createSingleEntityHandler?.data)
  return (
    <ModBox {...styles.container} show={isAccessible(accessConfig, 'read')}>
      {createSingleEntityHandler?.state === 'fulfilled' && (
        <StatusComp
          type={EmType.createSingleEntity}
          isCreateSuccess={true}
          onBackPress={undefined}
          applicationId={createSingleEntityHandler.data?.data?.applicationId}
          isUserCreationPressed={false}
          navigateToCreateGroup={() => {
            try {
              setCreateEntityValid(false)
              setBusinessdataValid(false)
              setCreationStatusValid(false)
              setContactProfileValid(false)
              setIsReset(true)
              saveContactProfileData(false)
              resetCreateSingleEntitySelections()
            } catch (e) {
              console.log('e', e)
            }
            navigation.reset({
              index: 0,
              routes: [{ name: 'createSingleEntity' }],
            })
          }}
          showSuccess={true}
          navigateToMyAppQueue={() => navigation.navigate('makerMyQueue')}
        />
      )}
      <Header
        currentStep={currentStep}
        selectedGroupName={selectedGroupName}
        groupBusinessName={groupBusinessName}
        selectedSubGroupName={selectedSubGroupName}
        showAllFields={handleShowAllFields}
      />
      <Box flexDirection={'row'} f={1}>
        <Box w={220}>
          <VerticalStepIndicator currentStep={currentStep} steps={steps} onStepPressed={onStepPressed} />
        </Box>
        <Box flexGrow={1} f={1} overflow={'auto'} testID="vertical-scroll">
          {getScreen[currentStep]}
        </Box>
      </Box>
      <Footer
        hide={hideFooter}
        setCurrentStep={handleSetCurrentStep}
        currentStep={currentStep}
        entityParentTypeSelected={entityParentTypeSelected}
        setHideFooter={setHideFooter}
        setCreateEntityValid={setCreateEntityValid}
        setBusinessdataValid={setBusinessdataValid}
        setCreationStatusValid={setCreationStatusValid}
        setContactProfileValid={setContactProfileValid}
        setIsReset={setIsReset}
        createEntityValid={createEntityValid}
        isBusinessDataValid={isBusinessDataValid}
        isContactProfileValid={isContactProfileValid}
        isSettlementDetailsValid={true}
        creationStatusValid={creationStatusValid}
        onSavePressed={onSavePressed}
        saveContactProfileData={saveContactProfileData}
        resetCreateSingleEntitySelections={resetCreateSingleEntitySelections}
        isLoading={createSingleEntityHandler.state === 'pending'}
      />
      <FullScreenLoader show={createSingleEntityHandler?.state === 'pending'} />
    </ModBox>
  )
}

export default CreateSingleEntity
